import type { Word } from './types';

export const WORDS_RU: Omit<Word, 'level'>[] = [
{
"id": 1001,
"w": "семья",
"ipa": "семья́",
"pos": "noun",
"uz": "oila",
"ex": "У меня большая семья.",
"exT": "Mening oilam katta.",
"topic": "Oila"
},
{
"id": 1002,
"w": "мама",
"ipa": "ма́ма",
"pos": "noun",
"uz": "ona, oyi",
"ex": "Мама на кухне.",
"exT": "Oyim oshxonada.",
"topic": "Oila"
},
{
"id": 1003,
"w": "папа",
"ipa": "па́па",
"pos": "noun",
"uz": "ota, dada",
"ex": "Папа работает в банке.",
"exT": "Dadam bankda ishlaydi.",
"topic": "Oila"
},
{
"id": 1004,
"w": "бабушка",
"ipa": "ба́бушка",
"pos": "noun",
"uz": "buvi",
"ex": "Бабушка печёт хлеб.",
"exT": "Buvim non yopyapti.",
"topic": "Oila"
},
{
"id": 1005,
"w": "дедушка",
"ipa": "де́душка",
"pos": "noun",
"uz": "bobo",
"ex": "Дедушка читает газету.",
"exT": "Bobom gazeta oʻqiyapti.",
"topic": "Oila"
},
{
"id": 1006,
"w": "брат",
"ipa": "брат",
"pos": "noun",
"uz": "aka, uka",
"ex": "У меня два брата.",
"exT": "Mening ikkita akam bor.",
"topic": "Oila"
},
{
"id": 1007,
"w": "сестра",
"ipa": "сестра́",
"pos": "noun",
"uz": "opa, singil",
"ex": "Моя сестра студентка.",
"exT": "Singlim talaba.",
"topic": "Oila"
},
{
"id": 1008,
"w": "сын",
"ipa": "сын",
"pos": "noun",
"uz": "oʻgʻil",
"ex": "Их сын учится в школе.",
"exT": "Ularning oʻgʻli maktabda oʻqiydi.",
"topic": "Oila"
},
{
"id": 1009,
"w": "дочь",
"ipa": "дочь",
"pos": "noun",
"uz": "qiz (farzand)",
"ex": "У них две дочери.",
"exT": "Ularning ikki qizi bor.",
"topic": "Oila"
},
{
"id": 1010,
"w": "дети",
"ipa": "де́ти",
"pos": "noun",
"uz": "bolalar",
"ex": "Дети играют во дворе.",
"exT": "Bolalar hovlida oʻynayapti.",
"topic": "Oila"
},
{
"id": 1011,
"w": "еда",
"ipa": "еда́",
"pos": "noun",
"uz": "ovqat, taom",
"ex": "Еда очень вкусная.",
"exT": "Ovqat juda mazali.",
"topic": "Ovqat"
},
{
"id": 1012,
"w": "хлеб",
"ipa": "хлеб",
"pos": "noun",
"uz": "non",
"ex": "Купи хлеб, пожалуйста.",
"exT": "Non olib kel, iltimos.",
"topic": "Ovqat"
},
{
"id": 1013,
"w": "вода",
"ipa": "вода́",
"pos": "noun",
"uz": "suv",
"ex": "Стакан воды, пожалуйста.",
"exT": "Bir stakan suv, iltimos.",
"topic": "Ovqat"
},
{
"id": 1014,
"w": "молоко",
"ipa": "молоко́",
"pos": "noun",
"uz": "sut",
"ex": "Я пью молоко.",
"exT": "Men sut ichaman.",
"topic": "Ovqat"
},
{
"id": 1015,
"w": "кофе",
"ipa": "ко́фе",
"pos": "noun",
"uz": "qahva",
"ex": "Я пью кофе утром.",
"exT": "Ertalab qahva ichaman.",
"topic": "Ovqat"
},
{
"id": 1016,
"w": "сок",
"ipa": "сок",
"pos": "noun",
"uz": "sharbat",
"ex": "Апельсиновый сок, пожалуйста.",
"exT": "Apelsin sharbati, iltimos.",
"topic": "Ovqat"
},
{
"id": 1017,
"w": "мясо",
"ipa": "мя́со",
"pos": "noun",
"uz": "goʻsht",
"ex": "Я не ем мясо.",
"exT": "Men goʻsht yemayman.",
"topic": "Ovqat"
},
{
"id": 1018,
"w": "рыба",
"ipa": "ры́ба",
"pos": "noun",
"uz": "baliq",
"ex": "На ужин рыба.",
"exT": "Kechki ovqatga baliq.",
"topic": "Ovqat"
},
{
"id": 1019,
"w": "курица",
"ipa": "ку́рица",
"pos": "noun",
"uz": "tovuq",
"ex": "Суп с курицей.",
"exT": "Tovuqli shoʻrva.",
"topic": "Ovqat"
},
{
"id": 1020,
"w": "яйцо",
"ipa": "яйцо́",
"pos": "noun",
"uz": "tuxum",
"ex": "Я ем два яйца на завтрак.",
"exT": "Nonushtaga ikkita tuxum yeyman.",
"topic": "Ovqat"
},
{
"id": 1021,
"w": "сыр",
"ipa": "сыр",
"pos": "noun",
"uz": "pishloq",
"ex": "Хлеб с сыром.",
"exT": "Pishloqli non.",
"topic": "Ovqat"
},
{
"id": 1022,
"w": "масло",
"ipa": "ма́сло",
"pos": "noun",
"uz": "sariyogʻ, yogʻ",
"ex": "Купи масло.",
"exT": "Sariyogʻ olib kel.",
"topic": "Ovqat"
},
{
"id": 1023,
"w": "дом",
"ipa": "дом",
"pos": "noun",
"uz": "uy",
"ex": "Мой дом рядом.",
"exT": "Uyim yaqin.",
"topic": "Uy"
},
{
"id": 1024,
"w": "квартира",
"ipa": "кварти́ра",
"pos": "noun",
"uz": "kvartira, xonadon",
"ex": "Мы живём в квартире.",
"exT": "Biz kvartirada yashaymiz.",
"topic": "Uy"
},
{
"id": 1025,
"w": "комната",
"ipa": "ко́мната",
"pos": "noun",
"uz": "xona",
"ex": "В квартире три комнаты.",
"exT": "Kvartirada uchta xona bor.",
"topic": "Uy"
},
{
"id": 1026,
"w": "кухня",
"ipa": "ку́хня",
"pos": "noun",
"uz": "oshxona",
"ex": "Мама на кухне.",
"exT": "Oyim oshxonada.",
"topic": "Uy"
},
{
"id": 1027,
"w": "спальня",
"ipa": "спа́льня",
"pos": "noun",
"uz": "yotoqxona",
"ex": "Спальня большая.",
"exT": "Yotoqxona katta.",
"topic": "Uy"
},
{
"id": 1028,
"w": "ванная",
"ipa": "ва́нная",
"pos": "noun",
"uz": "vannaxona",
"ex": "Ванная слева.",
"exT": "Vannaxona chap tomonda.",
"topic": "Uy"
},
{
"id": 1029,
"w": "туалет",
"ipa": "туале́т",
"pos": "noun",
"uz": "hojatxona",
"ex": "Где туалет?",
"exT": "Hojatxona qayerda?",
"topic": "Uy"
},
{
"id": 1030,
"w": "дверь",
"ipa": "дверь",
"pos": "noun",
"uz": "eshik",
"ex": "Закрой дверь.",
"exT": "Eshikni yop.",
"topic": "Uy"
},
{
"id": 1031,
"w": "окно",
"ipa": "окно́",
"pos": "noun",
"uz": "deraza",
"ex": "Открой окно.",
"exT": "Derazani och.",
"topic": "Uy"
},
{
"id": 1032,
"w": "стол",
"ipa": "стол",
"pos": "noun",
"uz": "stol",
"ex": "Ключи на столе.",
"exT": "Kalitlar stol ustida.",
"topic": "Uy"
},
{
"id": 1033,
"w": "сейчас",
"ipa": "сейча́с",
"pos": "adverb",
"uz": "hozir",
"ex": "Я сейчас занят.",
"exT": "Hozir bandman.",
"topic": "Vaqt"
},
{
"id": 1034,
"w": "сегодня",
"ipa": "сего́дня",
"pos": "adverb",
"uz": "bugun",
"ex": "Сегодня холодно.",
"exT": "Bugun sovuq.",
"topic": "Vaqt"
},
{
"id": 1035,
"w": "завтра",
"ipa": "за́втра",
"pos": "adverb",
"uz": "ertaga",
"ex": "Завтра выходной.",
"exT": "Ertaga dam olish kuni.",
"topic": "Vaqt"
},
{
"id": 1036,
"w": "вчера",
"ipa": "вчера́",
"pos": "adverb",
"uz": "kecha",
"ex": "Вчера был дождь.",
"exT": "Kecha yomgʻir yogʻdi.",
"topic": "Vaqt"
},
{
"id": 1037,
"w": "потом",
"ipa": "пото́м",
"pos": "adverb",
"uz": "keyin",
"ex": "Сначала урок, потом обед.",
"exT": "Avval dars, keyin tushlik.",
"topic": "Vaqt"
},
{
"id": 1038,
"w": "сначала",
"ipa": "снача́ла",
"pos": "adverb",
"uz": "avval, dastlab",
"ex": "Сначала помой руки.",
"exT": "Avval qoʻlingni yuv.",
"topic": "Vaqt"
},
{
"id": 1039,
"w": "теперь",
"ipa": "тепе́рь",
"pos": "adverb",
"uz": "endi, hozir",
"ex": "Теперь я понимаю.",
"exT": "Endi tushunaman.",
"topic": "Vaqt"
},
{
"id": 1040,
"w": "неделя",
"ipa": "неде́ля",
"pos": "noun",
"uz": "hafta",
"ex": "Я работаю пять дней в неделю.",
"exT": "Haftada besh kun ishlayman.",
"topic": "Vaqt"
},
{
"id": 1041,
"w": "город",
"ipa": "го́род",
"pos": "noun",
"uz": "shahar",
"ex": "Ташкент — большой город.",
"exT": "Toshkent katta shahar.",
"topic": "Shahar"
},
{
"id": 1042,
"w": "страна",
"ipa": "страна́",
"pos": "noun",
"uz": "mamlakat, davlat",
"ex": "Узбекистан — красивая страна.",
"exT": "Oʻzbekiston goʻzal mamlakat.",
"topic": "Shahar"
},
{
"id": 1043,
"w": "деревня",
"ipa": "дере́вня",
"pos": "noun",
"uz": "qishloq",
"ex": "Бабушка живёт в деревне.",
"exT": "Buvim qishloqda yashaydi.",
"topic": "Shahar"
},
{
"id": 1044,
"w": "улица",
"ipa": "у́лица",
"pos": "noun",
"uz": "koʻcha",
"ex": "Я живу на этой улице.",
"exT": "Men shu koʻchada yashayman.",
"topic": "Shahar"
},
{
"id": 1045,
"w": "площадь",
"ipa": "пло́щадь",
"pos": "noun",
"uz": "maydon",
"ex": "Мы встретимся на площади.",
"exT": "Maydonda uchrashamiz.",
"topic": "Shahar"
},
{
"id": 1046,
"w": "парк",
"ipa": "парк",
"pos": "noun",
"uz": "bogʻ, park",
"ex": "Пойдём в парк.",
"exT": "Bogʻga boraylik.",
"topic": "Shahar"
},
{
"id": 1047,
"w": "магазин",
"ipa": "магази́н",
"pos": "noun",
"uz": "doʻkon",
"ex": "Магазин открыт до десяти.",
"exT": "Doʻkon oʻngacha ochiq.",
"topic": "Shahar"
},
{
"id": 1048,
"w": "рынок",
"ipa": "ры́нок",
"pos": "noun",
"uz": "bozor",
"ex": "Я покупаю фрукты на рынке.",
"exT": "Mevalarni bozordan olaman.",
"topic": "Shahar"
},
{
"id": 1049,
"w": "банк",
"ipa": "банк",
"pos": "noun",
"uz": "bank",
"ex": "Банк закрыт в воскресенье.",
"exT": "Bank yakshanba kuni yopiq.",
"topic": "Shahar"
},
{
"id": 1050,
"w": "аптека",
"ipa": "апте́ка",
"pos": "noun",
"uz": "dorixona",
"ex": "Где ближайшая аптека?",
"exT": "Eng yaqin dorixona qayerda?",
"topic": "Shahar"
},
{
"id": 1051,
"w": "быть",
"ipa": "быть",
"pos": "verb",
"uz": "boʻlmoq",
"ex": "Я хочу быть врачом.",
"exT": "Men shifokor boʻlishni xohlayman.",
"topic": "Feʼllar"
},
{
"id": 1052,
"w": "знать",
"ipa": "знать",
"pos": "verb",
"uz": "bilmoq",
"ex": "Я знаю этот адрес.",
"exT": "Men bu manzilni bilaman.",
"topic": "Feʼllar"
},
{
"id": 1053,
"w": "понимать",
"ipa": "понима́ть",
"pos": "verb",
"uz": "tushunmoq",
"ex": "Вы меня понимаете?",
"exT": "Meni tushunyapsizmi?",
"topic": "Feʼllar"
},
{
"id": 1054,
"w": "говорить",
"ipa": "говори́ть",
"pos": "verb",
"uz": "gapirmoq",
"ex": "Говорите медленнее, пожалуйста.",
"exT": "Sekinroq gapiring, iltimos.",
"topic": "Feʼllar"
},
{
"id": 1055,
"w": "читать",
"ipa": "чита́ть",
"pos": "verb",
"uz": "oʻqimoq",
"ex": "Я читаю книгу.",
"exT": "Men kitob oʻqiyapman.",
"topic": "Feʼllar"
},
{
"id": 1056,
"w": "слушать",
"ipa": "слу́шать",
"pos": "verb",
"uz": "tinglamoq",
"ex": "Я слушаю музыку.",
"exT": "Men musiqa tinglayapman.",
"topic": "Feʼllar"
},
{
"id": 1057,
"w": "мочь",
"ipa": "мочь",
"pos": "verb",
"uz": "qila olmoq",
"ex": "Я могу помочь.",
"exT": "Men yordam bera olaman.",
"topic": "Feʼllar"
},
{
"id": 1058,
"w": "жить",
"ipa": "жить",
"pos": "verb",
"uz": "yashamoq",
"ex": "Где ты живёшь?",
"exT": "Qayerda yashaysan?",
"topic": "Feʼllar"
},
{
"id": 1059,
"w": "работать",
"ipa": "рабо́тать",
"pos": "verb",
"uz": "ishlamoq",
"ex": "Где вы работаете?",
"exT": "Qayerda ishlaysiz?",
"topic": "Feʼllar"
},
{
"id": 1060,
"w": "изучать",
"ipa": "изуча́ть",
"pos": "verb",
"uz": "oʻrganmoq",
"ex": "Я изучаю русский язык.",
"exT": "Men rus tilini oʻrganyapman.",
"topic": "Feʼllar"
},
{
"id": 1061,
"w": "делать",
"ipa": "де́лать",
"pos": "verb",
"uz": "qilmoq",
"ex": "Что ты делаешь?",
"exT": "Nima qilyapsan?",
"topic": "Feʼllar"
},
{
"id": 1062,
"w": "покупать",
"ipa": "покупа́ть",
"pos": "verb",
"uz": "sotib olmoq",
"ex": "Я покупаю хлеб.",
"exT": "Men non sotib olyapman.",
"topic": "Feʼllar"
},
{
"id": 1063,
"w": "думать",
"ipa": "ду́мать",
"pos": "verb",
"uz": "oʻylamoq",
"ex": "Я думаю, ты прав.",
"exT": "Oʻylaymanki, sen haqsan.",
"topic": "Feʼllar"
},
{
"id": 1064,
"w": "звонить",
"ipa": "звони́ть",
"pos": "verb",
"uz": "qoʻngʻiroq qilmoq",
"ex": "Позвони мне вечером.",
"exT": "Kechqurun menga qoʻngʻiroq qil.",
"topic": "Feʼllar"
},
{
"id": 1065,
"w": "отдыхать",
"ipa": "отдыха́ть",
"pos": "verb",
"uz": "dam olmoq",
"ex": "Летом мы отдыхаем на море.",
"exT": "Yozda dengizda dam olamiz.",
"topic": "Feʼllar"
},
{
"id": 1066,
"w": "гулять",
"ipa": "гуля́ть",
"pos": "verb",
"uz": "sayr qilmoq",
"ex": "Дети гуляют в парке.",
"exT": "Bolalar bogʻda sayr qilyapti.",
"topic": "Feʼllar"
},
{
"id": 1067,
"w": "играть",
"ipa": "игра́ть",
"pos": "verb",
"uz": "oʻynamoq",
"ex": "Мальчики играют в футбол.",
"exT": "Oʻgʻil bolalar futbol oʻynayapti.",
"topic": "Feʼllar"
},
{
"id": 1068,
"w": "готовить",
"ipa": "гото́вить",
"pos": "verb",
"uz": "tayyorlamoq, pishirmoq",
"ex": "Мама готовит плов.",
"exT": "Onam palov pishiryapti.",
"topic": "Feʼllar"
},
{
"id": 1069,
"w": "начинать",
"ipa": "начина́ть",
"pos": "verb",
"uz": "boshlamoq",
"ex": "Урок начинается в девять.",
"exT": "Dars toʻqqizda boshlanadi.",
"topic": "Feʼllar"
},
{
"id": 1070,
"w": "любить",
"ipa": "люби́ть",
"pos": "verb",
"uz": "sevmoq, yaxshi koʻrmoq",
"ex": "Я люблю свою семью.",
"exT": "Men oilamni yaxshi koʻraman.",
"topic": "Feʼllar"
},
{
"id": 1071,
"w": "большой",
"ipa": "большо́й",
"pos": "adjective",
"uz": "katta",
"ex": "Большой город.",
"exT": "Katta shahar.",
"topic": "Sifatlar"
},
{
"id": 1072,
"w": "маленький",
"ipa": "ма́ленький",
"pos": "adjective",
"uz": "kichik, kichkina",
"ex": "Маленький ребёнок.",
"exT": "Kichkina bola.",
"topic": "Sifatlar"
},
{
"id": 1073,
"w": "новый",
"ipa": "но́вый",
"pos": "adjective",
"uz": "yangi",
"ex": "Новый телефон.",
"exT": "Yangi telefon.",
"topic": "Sifatlar"
},
{
"id": 1074,
"w": "старый",
"ipa": "ста́рый",
"pos": "adjective",
"uz": "eski; qari",
"ex": "Старый дом.",
"exT": "Eski uy.",
"topic": "Sifatlar"
},
{
"id": 1075,
"w": "молодой",
"ipa": "молодо́й",
"pos": "adjective",
"uz": "yosh",
"ex": "Молодой человек.",
"exT": "Yosh yigit.",
"topic": "Sifatlar"
},
{
"id": 1076,
"w": "хороший",
"ipa": "хоро́ший",
"pos": "adjective",
"uz": "yaxshi",
"ex": "Хороший день.",
"exT": "Yaxshi kun.",
"topic": "Sifatlar"
},
{
"id": 1077,
"w": "плохой",
"ipa": "плохо́й",
"pos": "adjective",
"uz": "yomon",
"ex": "Плохая погода.",
"exT": "Yomon ob-havo.",
"topic": "Sifatlar"
},
{
"id": 1078,
"w": "красивый",
"ipa": "краси́вый",
"pos": "adjective",
"uz": "chiroyli, goʻzal",
"ex": "Красивый город.",
"exT": "Chiroyli shahar.",
"topic": "Sifatlar"
},
{
"id": 1079,
"w": "интересный",
"ipa": "интере́сный",
"pos": "adjective",
"uz": "qiziqarli",
"ex": "Интересный фильм.",
"exT": "Qiziqarli film.",
"topic": "Sifatlar"
},
{
"id": 1080,
"w": "длинный",
"ipa": "дли́нный",
"pos": "adjective",
"uz": "uzun",
"ex": "Длинная дорога.",
"exT": "Uzun yoʻl.",
"topic": "Sifatlar"
},
{
"id": 1081,
"w": "короткий",
"ipa": "коро́ткий",
"pos": "adjective",
"uz": "qisqa",
"ex": "Короткий текст.",
"exT": "Qisqa matn.",
"topic": "Sifatlar"
},
{
"id": 1082,
"w": "высокий",
"ipa": "высо́кий",
"pos": "adjective",
"uz": "baland",
"ex": "Высокий дом.",
"exT": "Baland uy.",
"topic": "Sifatlar"
},
{
"id": 1083,
"w": "низкий",
"ipa": "ни́зкий",
"pos": "adjective",
"uz": "past",
"ex": "Низкий стол.",
"exT": "Past stol.",
"topic": "Sifatlar"
},
{
"id": 1084,
"w": "горячий",
"ipa": "горя́чий",
"pos": "adjective",
"uz": "issiq (qaynoq)",
"ex": "Горячий чай.",
"exT": "Issiq choy.",
"topic": "Sifatlar"
},
{
"id": 1085,
"w": "цвет",
"ipa": "цвет",
"pos": "noun",
"uz": "rang",
"ex": "Какой твой любимый цвет?",
"exT": "Sevimli ranging qaysi?",
"topic": "Ranglar"
},
{
"id": 1086,
"w": "белый",
"ipa": "бе́лый",
"pos": "adjective",
"uz": "oq",
"ex": "Белый снег.",
"exT": "Oq qor.",
"topic": "Ranglar"
},
{
"id": 1087,
"w": "чёрный",
"ipa": "чёрный",
"pos": "adjective",
"uz": "qora",
"ex": "Чёрный кот.",
"exT": "Qora mushuk.",
"topic": "Ranglar"
},
{
"id": 1088,
"w": "красный",
"ipa": "кра́сный",
"pos": "adjective",
"uz": "qizil",
"ex": "Красное яблоко.",
"exT": "Qizil olma.",
"topic": "Ranglar"
},
{
"id": 1089,
"w": "голова",
"ipa": "голова́",
"pos": "noun",
"uz": "bosh",
"ex": "У меня болит голова.",
"exT": "Boshim ogʻriyapti.",
"topic": "Tana"
},
{
"id": 1090,
"w": "рука",
"ipa": "рука́",
"pos": "noun",
"uz": "qoʻl",
"ex": "Помой руки.",
"exT": "Qoʻlingni yuv.",
"topic": "Tana"
},
{
"id": 1091,
"w": "нога",
"ipa": "нога́",
"pos": "noun",
"uz": "oyoq",
"ex": "У него болит нога.",
"exT": "Uning oyogʻi ogʻriyapti.",
"topic": "Tana"
},
{
"id": 1092,
"w": "глаз",
"ipa": "глаз",
"pos": "noun",
"uz": "koʻz",
"ex": "У неё голубые глаза.",
"exT": "Uning koʻzlari moviy.",
"topic": "Tana"
},
{
"id": 1093,
"w": "ухо",
"ipa": "у́хо",
"pos": "noun",
"uz": "quloq",
"ex": "У меня болит ухо.",
"exT": "Qulogʻim ogʻriyapti.",
"topic": "Tana"
},
{
"id": 1094,
"w": "нос",
"ipa": "нос",
"pos": "noun",
"uz": "burun",
"ex": "У ребёнка маленький нос.",
"exT": "Bolaning burni kichkina.",
"topic": "Tana"
},
{
"id": 1095,
"w": "библиотека",
"ipa": "библиоте́ка",
"pos": "noun",
"uz": "kutubxona",
"ex": "Я читаю в библиотеке.",
"exT": "Men kutubxonada oʻqiyman.",
"topic": "Taʼlim"
},
{
"id": 1096,
"w": "школа",
"ipa": "шко́ла",
"pos": "noun",
"uz": "maktab",
"ex": "Сын ходит в школу.",
"exT": "Oʻgʻlim maktabga qatnaydi.",
"topic": "Taʼlim"
},
{
"id": 1097,
"w": "университет",
"ipa": "университе́т",
"pos": "noun",
"uz": "universitet",
"ex": "Я учусь в университете.",
"exT": "Men universitetda oʻqiyman.",
"topic": "Taʼlim"
},
{
"id": 1098,
"w": "студент",
"ipa": "студе́нт",
"pos": "noun",
"uz": "talaba",
"ex": "Он студент.",
"exT": "U talaba.",
"topic": "Taʼlim"
},
{
"id": 1099,
"w": "урок",
"ipa": "уро́к",
"pos": "noun",
"uz": "dars",
"ex": "Урок начинается в девять.",
"exT": "Dars toʻqqizda boshlanadi.",
"topic": "Taʼlim"
},
{
"id": 1100,
"w": "класс",
"ipa": "класс",
"pos": "noun",
"uz": "sinf",
"ex": "В классе двадцать учеников.",
"exT": "Sinfda yigirma oʻquvchi bor.",
"topic": "Taʼlim"
}
];
